import { NgModule } from '@angular/core';

import { DateAdapter, MatNativeDateModule } from '@angular/material/core';
import { MatStepperModule } from '@angular/material/stepper';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTooltipModule } from '@angular/material/tooltip';

import { CustomDateAdapter } from '@core/adapters/custom-date-adapter';

@NgModule({
	exports: [
		MatStepperModule,
		MatFormFieldModule,
		MatSelectModule,
		MatTabsModule,
		MatAutocompleteModule,
		MatInputModule,
		MatIconModule,
		MatDatepickerModule,
		MatNativeDateModule,
		MatExpansionModule,
		MatTooltipModule
	],
	providers: [
		{
			provide: DateAdapter,
			useClass: CustomDateAdapter
		}
	]
})
export class MaterialModule {

	constructor(private dateAdapter: DateAdapter<Date>) {
		this.dateAdapter.setLocale('nl-NL')
	}
}